<script setup>
import { reactive, onMounted } from "vue";

import { RouterAdapter } from "@astrocentro-webapp/ui/modules/commons/adapters/router/native/RouterAdapter";
import { HttpAdapter } from "@astrocentro-webapp/ui/modules/commons/adapters/http/axios/HttpAdapter";
import { FormatFiltersHelper } from "@astrocentro-webapp/ui/modules/commons/helpers/FormatFiltersHelper";
import { SellerEntity } from "@astrocentro-webapp/ui/modules/sellers/entities/SellerEntity";
import { SellerPresentationCard } from "@astrocentro-webapp/ui/modules/sellers/components/SellerPresentationCard";

const state = reactive({
  sellers: [],
  extraParams: "",
});

const http = HttpAdapter.create();
const router = new RouterAdapter();

const getSellersEntities = (sellers) =>
  sellers.map((seller) => new SellerEntity(seller));

const getQueryStrings = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const hasSpecialtyFilter = router.route.params?.specialty ? true : false;
  const hasOrderFilter = urlSearchParams.getAll("ordenar-por").length;
  const limitFilter = router.route.query?.limit
    ? router.route.query?.limit
    : 24;

  state.extraParams = getExtraParams(urlSearchParams);
  urlSearchParams.delete("cta-text");
  urlSearchParams.delete("cta-color");
  urlSearchParams.delete("offset");
  urlSearchParams.set("limit", limitFilter);

  router.route.query?.tags &&
    urlSearchParams.set("tags", router.route.query?.tags);
  !hasSpecialtyFilter &&
    !hasOrderFilter &&
    urlSearchParams.append("order[]", "random");
  hasSpecialtyFilter &&
    urlSearchParams.set("especialidade", router.route.params?.specialty);
  urlSearchParams.set("relationships[]", "services");

  return decodeURIComponent(
    `?order[]=status,ASC&${FormatFiltersHelper.perform(
      urlSearchParams.toString()
    )}`
  );
};

const fetchSellers = async () => {
  const queryStrings = getQueryStrings();
  const { data: sellers } = await http.get(
    `${import.meta.env.VITE_ASTROCENTRO_API_URL}/v1/sellers${queryStrings}`
  );
  state.sellers = getSellersEntities(sellers);
};

const getExtraParams = (urlSearchParams) => {
  if (urlSearchParams.get("extra_params")) {
    const [extraParams] = urlSearchParams
      .toString()
      .match(/extra_params=(.*)/g);

    if (extraParams) {
      return decodeURIComponent(extraParams.replace("extra_params=", ""));
    }

    return "";
  }

  return "";
};

onMounted(() => {
  fetchSellers();
});
</script>

<template>
  <div class="root">
    <div class="d-flex flex-wrap">
      <div
        v-for="seller of state.sellers"
        class="col-12 col-sm-6 col-md-5 col-lg-3 p-2"
      >
        <SellerPresentationCard
          :seller="seller"
          :hasPromo="Boolean(router.route.query['tracker_id'])"
          :ctaOptions="{
            text: router.route.query['cta-text'],
            color: router.route.query['cta-color'],
          }"
          :trackerId="router.route.query['tracker_id']"
          :extraParams="state.extraParams"
          targetAttribute="_blank"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss">
@import "@astrocentro-webapp/ui/assets/stylesheets/app.scss";
@import "@astrocentro-webapp/ui/modules/sellers/components/SellerPresentationCard/SellerPresentationCard.scss";

.root {
  font-family: $font-family;
  font-size: $size-7;
}
</style>
